import { createContext, forwardRef, useId, useRef } from 'react';
import Draggable from 'react-draggable';

import Paper, { PaperProps } from '@mui/material/Paper';

export const DragHandleClassContext = createContext('draggable-dialog-title');

export const DraggablePaper = forwardRef<HTMLDivElement, PaperProps>(
  (props, forwardedRef) => {
    const nodeRef = useRef<HTMLDivElement | null>(null);
    const uniqueHandleClass = `draggable-dialog-title-${useId().replace(
      /:/g,
      ''
    )}`;

    return (
      <DragHandleClassContext.Provider value={uniqueHandleClass}>
        <Draggable
          handle={`.${uniqueHandleClass}`}
          cancel={'[class*="MuiDialogContent-root"], button, [role="button"]'}
          nodeRef={nodeRef}
          bounds="body"
        >
          <Paper
            ref={(node: HTMLDivElement | null) => {
              nodeRef.current = node;
              if (typeof forwardedRef === 'function') {
                forwardedRef(node);
              } else if (forwardedRef) {
                forwardedRef.current = node;
              }
            }}
            {...props}
            sx={{ ...((props.sx as object) ?? {}), margin: '0 !important' }}
          />
        </Draggable>
      </DragHandleClassContext.Provider>
    );
  }
);

DraggablePaper.displayName = 'DraggablePaper';
